import React, {useMemo, useState} from "react";
import {FtSwitch} from "@/component/input/FtSwitch";
import {FtDialog} from "@/common/FtDialog";
import {FtDate} from "@/common/util/FtDate";
import {FtButton} from "@/common/FtButton";
import {useCreateTransaction} from "@/hook/useTransactions";
import {ErrorUtil} from "@/utils/ErrorUtil";
import {TransData} from "@/common/dto/TransData";
import {TransactionForm} from "@/component/form/TransactionForm";
import {TransUtils} from "@/utils/TransUtils";

interface Props {
    handleClose: () => void;
    inAccountId?: number;
    outAccountId?: number;
    transactDate?: string;
    amount?: number;
    detail?: string;
}

export function AddTransDialog(props: Props) {
    const [continueInput, setContinueInput] = useState(false);
    const [showContinueMessage, setShowContinueMessage] = useState(false);
    const createTransaction = useCreateTransaction();

    const [data, setData] = useState<Partial<TransData>>({
        transactDate: props.transactDate ?? new FtDate().ymd("-"),
        amount: props.amount ?? 0,
        detail: props.detail ?? "",
        inAccountId: props.inAccountId,
        outAccountId: props.outAccountId,
    });

    const isValid = useMemo(() => {
        return data.transactDate && data.inAccountId && data.outAccountId && data.detail?.trim();
    }, [data]);

    async function handleSubmit() {
        try {
            await createTransaction.mutateAsync(TransUtils.validateTransData(data));

            if (continueInput) {
                setShowContinueMessage(true);
                setTimeout(() => setShowContinueMessage(false), 2000);

                setData({
                    ...data,
                    amount: 0,
                    detail: "",
                });
            } else {
                props.handleClose();
            }
        } catch (e) {
            alert("오류: " + ErrorUtil.getErrorMessage(e));
        }
    }

    if (!open) return null;

    return (
        <FtDialog title="거래 등록" handleClose={props.handleClose}>
            <TransactionForm data={data} setData={setData} />

            <div style={{minHeight: "60px"}}>
                {showContinueMessage && (
                    <div style={{padding: "8px 0", fontSize: 14, color: "green"}}>등록 되었습니다. 이어서 등록 하세요.</div>
                )}
            </div>

            <div style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
            }}>
                <div>
                    <FtSwitch label="계속해서 입력" checked={continueInput} onChange={setContinueInput}/>
                </div>

                <div style={{display: "flex", gap: 8}}>
                    <FtButton onClick={() => props.handleClose()}>취소</FtButton>
                    <FtButton variant="contained" disabled={!isValid} onClick={handleSubmit}>저장</FtButton>
                </div>
            </div>
        </FtDialog>
    );
}
